/**
 * Централизованный логгер с подавлением в production.
 *
 * В production (NODE_ENV === 'production') все уровни кроме error подавляются.
 * console.error сохраняется — критические ошибки должны быть видны в production
 * для мониторинга и отладки.
 *
 * @example
 * import { logger } from '../utils/logger';
 * logger.error('AuthService', 'Login failed:', error);
 */

const IS_DEV = process.env.NODE_ENV !== 'production';

/* eslint-disable no-console */
export const logger = {
  /** Всегда логируется (критические ошибки) */
  error: (...args) => console.error(...args),

  /** Только в development (предупреждения, нештатные ситуации) */
  warn: (...args) => { if (IS_DEV) console.warn(...args); },

  /** Только в development (информационные сообщения) */
  info: (...args) => { if (IS_DEV) console.info(...args); },

  /** Только в development (отладочные сообщения) */
  debug: (...args) => { if (IS_DEV) console.log(...args); },
};
/* eslint-enable no-console */

export default logger;
